// extracted by mini-css-extract-plugin
export default {"topic":"summary_topic__ZB9B5","trending_negative":"summary_trending_negative__JfZhN","trending_positive":"summary_trending_positive__4DIoE"};